export default __webpack_public_path__ + "static/media/contato.603907d3.png";